import Overview from '../service/overview'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 概况
    summary(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Overview.summary(payload), {
        type: 'info',
        success,
        fail
      })
    },
    statscashorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Overview.statscashorder(payload), {
        type: 'info',
        success,
        fail
      })
    },
    statspointsorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Overview.statspointsorder(payload), {
        type: 'info',
        success,
        fail
      })
    },
    statswxuserlogincount(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Overview.statswxuserlogincount(payload), {
        type: 'info',
        success,
        fail
      })
    },
    statswxuserregcount(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Overview.statswxuserregcount(payload), {
        type: 'info',
        success,
        fail
      })
    },
    statswxuserloginentry(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Overview.statswxuserloginentry(payload), {
        type: 'info',
        success,
        fail
      })
    }
  }
}
